import React, {Component} from 'react';
import { Fab, Action } from 'react-tiny-fab';
import {Button, Icon} from "semantic-ui-react";
// import 'react-tiny-fab/dist/styles.css';

class FloattingButton extends Component {
    captureOutboundLink = function(url) {
        if (typeof gtag === "function") {
            gtag("event", "pcbgogo", {"event_category": "3d ads", "event_label": "pcbgogo"});
        }
    }

    clicked = function(category) {
        //sigend in
        if (this.props.is_user_signed_in){
            //let url = `https://dcaclab.com/forum/session/sso?return_path=https://dcaclab.com/forum/new-topic?title=${topic}&body=&category=${category}`;
            let url = `https://dcaclab.com/forum/session/sso?return_path=https://dcaclab.com/forum/new-topic?title=&body=&category=questions`;
            document.cookie = `forum_intent=${category}`;
            url = "discourse/post_user_intent"
            window.open(encodeURI(url), '_blank');
        }else {
            //not signed in
            this.props.setTriedToSave(1);
        }
    }

    ideaButtonStyles = { backgroundColor: '#9EB83B', width: 50, borderRadius: 25 }
    bugButtonStyles = { backgroundColor: '#546E7A', width: 50, borderRadius: 25 }; // Dark Red/Maroon

    questionButtonStyles = { backgroundColor: '#f2ee1d', width: 50, borderRadius: 25 }
    render() {
        return(
            <Fab
                mainButtonStyles={{ backgroundColor: '#36454F', width: 56, borderRadius: 28 }}

                style={{
                    bottom: 0,
                    left: 0,
                }}
                icon={
                    <>
                    <span style={{padding: 0, margin: 0}}>+</span>
                    </>
                }
                alwaysShowTitle={false}
            >
                <Action
                    style={this.bugButtonStyles}
                    text="Feedback"
                    onClick={()=>{this.clicked('bugs')}}
                >
                    <Icon name='hand point right' />
                </Action>

                <Action
                    style={this.ideaButtonStyles}
                    text="Feature request"
                    onClick={()=>{this.clicked('ideas')}}
                >
                    <Icon name='idea' />
                </Action>

                <Action
                    style={this.questionButtonStyles}
                    text="Question"
                    onClick={()=>{this.clicked('questions')}}
                >
                    <Icon color='black' name='question' />
                </Action>

            </Fab>
        )
    }
}

export default FloattingButton;
